<div class="custom-field-table__wrapper">
  <table class="lum-table lum-table--classic">
    <tr class="table__head-row">
      <th>ID</th>
      <th>Warehouse Group</th>
      <th>Show Inventory Numbers</th>
    </tr>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById; let i = index">
        <td>{{ row.id }}</td>
        <td>{{ row.label }}</td>
        <td>
          <mat-slide-toggle
            [checked]="row.b2bInventoryNumbersEnabled"
            (change)="toggleEvent.emit(row.id)"
          ></mat-slide-toggle>
        </td>
      </tr>
    </tbody>
  </table>
</div>
